import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function InstallButton() {
  const [deferred, setDeferred] = useState(null);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;
    setIsIos(/iphone|ipad|ipod/i.test(navigator.userAgent));
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!deferred && !isIos) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else if (isIos) {
      toast.info("Tap the Share button in Safari, then 'Add to Home Screen' to install Baeboo's Wardrobe", { duration: 7000 });
    }
  };

  return (
    <button
      onClick={install}
      className="flex items-center gap-1.5 rounded-full border-2 border-ink/15 px-4 py-2 text-xs font-semibold text-ink hover:border-terracotta hover:text-terracotta transition-colors duration-300"
      data-testid="install-app-btn"
      aria-label="Install app"
    >
      <Download className="w-3.5 h-3.5" />
      <span className="hidden lg:inline">Install App</span>
    </button>
  );
}
